






import tenantsService from '@/tenants/services/tenants-service'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Imprint extends Vue {
  private loading = false

  private async initSort() {
    this.loading = true
    await tenantsService.initSort()
    this.loading = false
  }
}
